<template lang="html">
  <section class="comp-ctn-docs">
  	<custom-select-user v-model="currentClient" :items="clients"/>
		<div class="ctn-docs row" v-if="currentClient">
			<tile-doc :doc="doc" v-for="(doc, key) in docs" v-bind:key="key"/>
			<div class="no-docs" v-if="docs.length === 0">
				Pas de document pour le moment
			</div>
		</div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import TileDoc from '@/common/components/tile-doc'
import emma from '@/common/services/Emma'
import CustomSelectUser from '@/common/components/Form/CustomSelectUser'
export default {
	components: {
		CustomSelectUser,
		TileDoc
	},
	data () {
		return {
			currentClient: null,
			clients: [],
			docs: []
		}
	},
	mounted () {
		this.clients = this.user.clients
		this.currentClient = this.clients[0]
	},
	methods: {
		setClient (value) {
			this.selected = value.key
		},
		fetchDocs () {
			this.docs = []
			emma.get('api/documents/company-information/' + this.currentClient.id).then((result) => {
				if (result.data.success) {
					this.docs = result.data.documents
				}
			}).catch((error) => {
				console.warn(error)
			})
		}
	},
	watch: {
		currentClient () {
			this.fetchDocs()
		}
	},
	computed: {
		...mapGetters({
			user: 'user'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// CompanySignature.vue?395a0e48